import * as React from 'react';

function SvgFilterHorizontal(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M18.17 16.31H9.32a2.63 2.63 0 01-5.12 0H1.83v-1.3h2.39a2.63 2.63 0 015.08 0h8.87v1.3zm-12.74-.6a1.33 1.33 0 112.66 0 1.33 1.33 0 01-2.66 0zM9.32 4.9h8.85V3.6H9.3a2.63 2.63 0 00-5.08 0h-2.4v1.3H4.2a2.63 2.63 0 005.12 0zM6.76 2.97a1.33 1.33 0 100 2.66 1.33 1.33 0 000-2.66zm8.35 6.8v-.04a1.33 1.33 0 100 .04zm3.06-.63h-1.83a2.63 2.63 0 00-5.12 0h-9.4v1.3h9.43a2.63 2.63 0 005.07 0h1.85v-1.3z", clipRule: "evenodd" })));
}

export default SvgFilterHorizontal;
